export default __webpack_public_path__ + "static/dan-nistor-08dda18daf71c56f6781ac619dbae712.svg";